export class UpdateDataCatalogPipelineRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "definition",
            "baseName": "definition",
            "type": "DataCatalogPipelineDefinition",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "DataCatalogPipelineSchedule",
            "format": ""
        },
        {
            "name": "expectedVersion",
            "baseName": "expectedVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "changeNote",
            "baseName": "changeNote",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentSessionId",
            "baseName": "agentSessionId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateDataCatalogPipelineRequest.attributeTypeMap;
    }
    constructor() {
    }
}
